import React, { useEffect, useState } from "react";

import { getLanguageFromLocalStorage, goTo, useGetFullPopup } from "utils";

import { LANGUAGE_CODE } from "consts";

import { ExtraInfoProps } from "models";

import { Button, Drawer, Skeleton, VideoPlayer } from "components";

export const ExtraInfo = ({ className, type, visible, setVisible, zIndex = 10002 }: ExtraInfoProps) => {
  const [currentType, setCurrentType] = useState<string | null>("");

  const languageFromStorage = getLanguageFromLocalStorage();
  const { popup, popupIsLoading } = useGetFullPopup({ type, language: languageFromStorage || LANGUAGE_CODE.GERMAN });

  useEffect(() => {
    if (currentType !== type) {
      setCurrentType(type);
    }
  }, [type, visible, currentType]);

  return (
    <Drawer
      dataTestId={`extra-info-drawer-${type}`}
      className={className}
      title={popup?.headline || ""}
      visible={visible}
      onClose={() => setVisible(false)}
      zIndex={zIndex}
      footer={
        popup?.button &&
        popup?.buttonText && [
          <Button dataTestId="popup-button" type="primary" onClick={(e) => goTo(e, null, popup.buttonLink, true)} key={0}>
            {popup.buttonText}
          </Button>,
        ]
      }
    >
      {(popupIsLoading || !popup) && <Skeleton type="paragraph" rows={3} />}
      {(!popupIsLoading || popup) && (
        <>
          {popup?.video && <VideoPlayer dataTestId="popup-video-player" placeholderImages={popup.video.placeholderImages} vimeoId={popup.video.id} />}
          <div data-testid="popup-content" className="content" dangerouslySetInnerHTML={{ __html: popup?.content || "" }} />
        </>
      )}
    </Drawer>
  );
};
